export const didPrefetch = (state) => state.prefetch.didPrefetch;
export const isPrefetching = (state) => state.prefetch.isPrefetching;
export const lastPrefetch = (state) => state.prefetch.lastPrefetch;
